import { render, staticRenderFns } from "./VolunteerSuccess.vue?vue&type=template&id=dc06c45e&"
import script from "./VolunteerSuccess.vue?vue&type=script&lang=js&"
export * from "./VolunteerSuccess.vue?vue&type=script&lang=js&"
import style0 from "./VolunteerSuccess.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports